import type { BooleanHotelFilter } from '@apps/main/new-desktop/modules/hotelFilters/model/hotelFilters';
import { HotelFilter } from '@apps/main/new-desktop/modules/hotelFilters/model/hotelFilters';

import type { AppCheckboxListOption } from '@libs/ui';

export const HOTEL_SELECTION_PRICE_STEP = 100;
export const HOTEL_SELECTION_PRICE_SCALE_STEPS = 100;
export const HOTEL_SELECTION_HISTOGRAM_BUCKETS = 20;

const GUEST_RATING_ANY = 0;
const GUEST_RATING_GOOD = 7;
const GUEST_RATING_VERY_GOOD = 8;
const GUEST_RATING_EXCELLENT = 9;

export const HOTEL_SELECTION_GUEST_RATINGS = [
  GUEST_RATING_ANY,
  GUEST_RATING_GOOD,
  GUEST_RATING_VERY_GOOD,
  GUEST_RATING_EXCELLENT,
] as const;

export type HotelSelectionGuestRating =
  (typeof HOTEL_SELECTION_GUEST_RATINGS)[number];

export const HOTEL_SELECTION_ANY_STAR_CHIP = 0;
export const HOTEL_SELECTION_UNFILTERED_STAR_RATING = 1;
const STAR_RATING_THREE = 3;

export const HOTEL_SELECTION_FOUR_STAR_RATING = 4;
export const HOTEL_SELECTION_FIVE_STAR_RATING = 5;

export const HOTEL_SELECTION_STAR_RATINGS = [
  HOTEL_SELECTION_ANY_STAR_CHIP,
  STAR_RATING_THREE,
  HOTEL_SELECTION_FOUR_STAR_RATING,
  HOTEL_SELECTION_FIVE_STAR_RATING,
] as const;

export type HotelSelectionStarRating =
  (typeof HOTEL_SELECTION_STAR_RATINGS)[number];

export const HOTEL_SELECTION_MINIMUM_RATING_SUFFIX = '+';

export const HOTEL_SELECTION_VISIBLE_OPTIONS_LIMIT = 5;

export interface HotelSelectionClientFilters {
  maxPricePerNight: number | null;
  minimumGuestRating: HotelSelectionGuestRating;
  previouslySeenOnly: boolean;
}

export interface HotelSelectionFilterCandidate {
  hotelCode: string;
  totalPrice?: number;
  guestRatingOverTen?: number;
}

export type HotelSelectionFilterOption =
  AppCheckboxListOption<BooleanHotelFilter>;

export const HOTEL_SELECTION_POPULAR_FILTERS: BooleanHotelFilter[] = [
  HotelFilter.MealsBreakfast,
  HotelFilter.MealsAllInclusive,
  HotelFilter.AmenitiesPool,
];
